import CartInfo from '@theme/components/cart/CartInfo'
import Logo from '@theme/components/molecule/Logo'

export default {
  components: {
    CartInfo,
    Logo,
  },
  props: {
    contact: {
      type: Object,
      default() {
        return this.$store.state.globals.contact
      },
    },
  },
}
